<script setup lang="ts">
import { computed } from "vue";
import { Firebase } from "@/utils/firebase-utility";
import FooterLink from "./footer-link.vue";
import router from "@/router";

const path = computed(() => {
  return router.currentRoute.value.path;
});

const emit = defineEmits<{
  (e: "closeSideMenu"): void;
}>();

function closeSideMenu() {
  emit("closeSideMenu");
}

function onLogout() {
  closeSideMenu();
  logout();
}

const logout = () => {
  Firebase.logout();
  location.reload();
};
</script>

<template>
  <div class="safearea-bottom bg-menu-base z-5 border-outline fixed bottom-0 left-0 right-0 border-t">
    <div class="flex h-12 w-full items-center">
      <div class="mx-1 flex grow flex-row justify-center gap-1">
        <FooterLink icon="house" link="/" :selected="path === '/'">ホーム</FooterLink>
        <template v-if="Firebase.organization.value?.plan === 'paid' || Firebase.organization.value?.plan === 'trial' || Firebase.organization.value?.plan === 'readonly'">
          <FooterLink icon="quote-left" link="/quotations/list" :selected="path.startsWith('/quotations')">
            見積書
          </FooterLink>
          <FooterLink icon="file-invoice-dollar" link="/invoices/list" :selected="path.startsWith('/invoices')">
            請求書
          </FooterLink>
          <FooterLink icon="truck" link="/delivery_notes/list" :selected="path.startsWith('/delivery_notes')">
            納品書
          </FooterLink>
          <FooterLink icon="address-book" link="/clients" :selected="path.startsWith('/clients')">取引先</FooterLink>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
